exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-63c89129] .el-tabs__nav-scroll {\n  float: right;\n}\n[data-v-63c89129] .el-tabs__nav-wrap {\n  margin-top: 0;\n  margin-bottom: -15px;\n}\n[data-v-63c89129] .el-tabs__nav {\n  background: #a0a19ce0;\n}\n[data-v-63c89129] .el-tabs__item {\n  color: white;\n}\n[data-v-63c89129] .el-tabs__item.is-active {\n  color: white;\n  background: #78a5e7;\n}\n[data-v-63c89129] .el-tabs--card > .el-tabs__header {\n  border-bottom: none;\n}\n", ""]);

// exports
